import { z } from 'zod';
import { FlowApiPageLimitSchema, FlowApiPageOffsetSchema } from '../pagination/pageLimit.js';
/** Whether a category is still offered, or kept only so the events filed under it still read. */
export var FlowStandardAnalyticEventCategoryStatus;
(function (FlowStandardAnalyticEventCategoryStatus) {
    FlowStandardAnalyticEventCategoryStatus["Active"] = "Active";
    FlowStandardAnalyticEventCategoryStatus["Deprecated"] = "Deprecated";
})(FlowStandardAnalyticEventCategoryStatus || (FlowStandardAnalyticEventCategoryStatus = {}));
/** Body the endpoints creating or replacing a category accept. */
export const FlowStandardAnalyticEventCategoryBodySchema = z.object({
    name: z.string().min(1),
    status: z.enum(FlowStandardAnalyticEventCategoryStatus).optional(),
});
/** Query parameters `GET /standard-analytic-event-categories` accepts. */
export const FlowStandardAnalyticEventCategoryListQuerySchema = z.object({
    q: z.string().describe('Return only categories whose name matches this.').optional(),
    status: z
        .enum(FlowStandardAnalyticEventCategoryStatus)
        .describe('Return only categories in this status.')
        .optional(),
    limit: FlowApiPageLimitSchema.describe('How many categories to return.').optional(),
    offset: FlowApiPageOffsetSchema.describe('How many matches to skip, for paging.').optional(),
    orderBy: z.string().describe('Column to order by, such as name.').optional(),
    orderDirection: z.enum(['asc', 'desc']).describe('Direction to order by.').optional(),
});
/** Path parameters the endpoints addressing one category accept. */
export const FlowStandardAnalyticEventCategoryIdParamsSchema = z.object({
    id: z.uuid().describe('The standard analytic event category.'),
});
//# sourceMappingURL=standardEventCategory.js.map